// @spec GHG-STR-006
'use client';

import { Outlet, createFileRoute } from '@tanstack/react-router';

import { SCOPE3_CATEGORY_BY_SLUG } from '@/features/ghg/config/scope3-categories';
import { scope3SearchSchema } from '@/features/ghg/pages/GhgScope3CalculationsPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/scope3/$category')({
  validateSearch: scope3SearchSchema,
  beforeLoad: ({ params }) => {
    const config = SCOPE3_CATEGORY_BY_SLUG.get(params.category);
    return {
      getTitle: () =>
        config
          ? i18n.t('ghg:scope3CategoryLayout.routeTitle', { number: config.number, label: config.label })
          : i18n.t('ghg:scope3CategoryLayout.routeTitleFallback'),
    };
  },
  component: Scope3CategoryLayout,
});

function Scope3CategoryLayout() {
  return <Outlet />;
}
